import {
  HelpHeader, SupportArticles, ArticleNav, SendFeedback,
} from './components';
import { JoinDiscord } from '../../components/JoinDiscord';

const Help = () => (
  <>
    <HelpHeader />
    <SupportArticles />
    <ArticleNav />
    <SendFeedback />
    <JoinDiscord />
  </>
);

export {
  Help,
};
